import * as React from "react";
import * as classnames from "classnames";
import { compose, withProps, defaultProps, setDisplayName, withState, withHandlers } from "recompose";
import { find, uniq, get, includes, compact, xor } from "lodash-es";
import Popper from "@d8660091/react-popper";
import Input from "../Input";
import Icon from "../Icon";
var enhance = compose(defaultProps({
    placeholder: "Select a value",
    emptyPlaceholder: "No items to be shown",
    items: [],
    isMultiple: false,
    selectedText: " selected"
}), withState("searchString", "setSearchString", ""), 
// modify items prop by searchString
withProps(function (props) { return ({
    activeItem: find(props.items, { value: props.value }),
    items: props.items.filter(function (item) {
        return (typeof item.label === "string" &&
            includes(item.label.toLocaleLowerCase(), props.searchString.toLocaleLowerCase()));
    })
}); }), withProps(function (props) { return ({
    groups: props.groups || uniq(props.items.map(function (item) { return item.group; })) || []
}); }), withState("activeGroup", "setActiveGroup", function (props) {
    return get(props.activeItem, "group", props.groups[0]);
}), withProps(function (props) { return ({
    groupedItems: props.items.filter(function (item) {
        if (props.isGrouped) {
            return item.group === props.activeGroup;
        }
        else {
            return true;
        }
    }),
    buttonText: (function () {
        if (props.activeItem) {
            return props.activeItem.label;
        }
        if (props.items.length === 0) {
            return props.emptyPlaceholder;
        }
        if (Array.isArray(props.value) && props.value.length > 0) {
            return props.value.length + props.selectedText;
        }
        return props.placeholder;
    })()
}); }), withHandlers({
    onItemClick: function (props) { return function (_a) {
        var value = _a.value, closePopper = _a.closePopper;
        return function () {
            if (props.isMultiple) {
                props.onChange(uniq(compact(xor(props.value, [value]))));
            }
            else {
                props.onChange(value);
                closePopper();
            }
        };
    }; }
}), setDisplayName("AdvancedSelect"));
var AdvancedSelect = enhance(function (props) {
    return (React.createElement(Popper, { options: {
            placement: "bottom-start",
            modifiers: {
                offset: {
                    offset: 1
                }
            },
            onUpdate: function (_a) {
                var popper = _a.instance.popper, width = _a.offsets.reference.width;
                popper.style.minWidth = width + "px"; // min width should be the trigger's width
            }
        }, renderRef: function (_a) {
            var setReference = _a.setReference, toggle = _a.toggle;
            return (React.createElement(React.Fragment, null,
                props.label && React.createElement("label", { className: "wds-label" }, props.label),
                React.createElement("button", { type: "button", ref: setReference, onClick: toggle, className: classnames("sui-advanced-select__trigger", props.className), style: props.style, disabled: props.disabled }, props.buttonText)));
        }, renderPop: function (_a) {
            var setPop = _a.setPop, close = _a.close;
            return props.items.length > 0 || props.isSearchable || props.renderFooter ? (React.createElement("div", { ref: setPop, className: "sui-advanced-select__menu" },
                props.isSearchable && (React.createElement("div", { className: "sui-advanced-select__search" },
                    React.createElement(Input, { value: props.searchString, onChange: function (e) { return props.setSearchString(e.target.value); }, stretched: true },
                        React.createElement(Icon, null, "s")))),
                React.createElement("div", { style: props.groupsItemsStyle, className: "sui-advanced-select__groups-items" },
                    props.isGrouped && (React.createElement("div", { className: "sui-advanced-select__groups", style: props.groupsStyle }, props.isGrouped &&
                        props.groups.map(function (group) { return (React.createElement("div", { key: (props.activeItem &&
                                props.activeItem.value) + "_" + group, onClick: function () {
                                props.setActiveGroup(group);
                            }, className: classnames("sui-advanced-select__item", {
                                "sui-advanced-select__item--active": props.activeGroup === group
                            }) }, group)); }))),
                    React.createElement("div", { className: "sui-advanced-select__items" }, props.groupedItems.map(function (item) { return (React.createElement("div", { key: (props.activeItem && props.activeItem.value) + "_" + item.value, onClick: props.onItemClick({
                            value: item.value,
                            closePopper: close
                        }), className: classnames("sui-advanced-select__item", {
                            "sui-advanced-select__item--active": props.value === item.value ||
                                (Array.isArray(props.value) &&
                                    includes(props.value, item.value))
                        }) },
                        item.label,
                        item.context && React.createElement("span", { className: "sui-advanced-select_item__context d-block float-right" }, item.context))); }))),
                props.renderFooter && (React.createElement("div", { className: "sui-advanced-select__footer" }, props.renderFooter(props))))) : null;
        } }));
});
export default AdvancedSelect;
//# sourceMappingURL=AdvancedSelect.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@sm/smapply-ui/dist/es/components/AdvancedSelect/AdvancedSelect.js
// module id = 1818
// module chunks = 17